// Отдельный модуль сохранён: на него ссылаются форма сделки и существующий тест.
import { createEntityMutations } from '../../../shared/api/createEntityMutations.js';
import { createDeal, type CreateDealInput, type DealListItem } from '../api/deals.client.js';

const createMutation = createEntityMutations<DealListItem, CreateDealInput>({
  key: 'deals',
  alsoInvalidate: ['contacts', 'companies'],
  create: createDeal,
});

export const useCreateDealMutation = createMutation.useCreate;
